const prefix = '@retailMedia/report'

export const CAMPAIGNS_GET_REPORT = `${prefix}/GET_REPORT`
export const CAMPAIGNS_GET_REPORT_COMPARE = `${prefix}/GET_REPORT_COMPARE`
export const CAMPAIGNS_GET_REPORT_REALTIME = `${prefix}/GET_REPORT_REALTIME`
export const CAMPAIGNS_GET_REPORT_HISTORY = `${prefix}/GET_REPORT_HISTORY`
export const CAMPAIGNS_GET_REPORT_HISTORY_COMPARE = `${prefix}/GET_REPORT_HISTORY_COMPARE`

export const types = {
  get: CAMPAIGNS_GET_REPORT,
  getCompare: CAMPAIGNS_GET_REPORT_COMPARE,
  getRealtime: CAMPAIGNS_GET_REPORT_REALTIME,
  getHistory: CAMPAIGNS_GET_REPORT_HISTORY,
  getHistoryCompare: CAMPAIGNS_GET_REPORT_HISTORY_COMPARE
} as const
